export enum FontSize {
	Small = 'small',
	Normal = 'normal',
	Large = 'large'
}
